// Layout.tsx
import { Avatar, Button, Dropdown, Layout, Menu, Space, Typography } from 'antd';
import {
  UserOutlined,
  InfoCircleOutlined,
  HomeOutlined,
  CommentOutlined,
  LogoutOutlined,
  DownOutlined,
  SmileOutlined,
  SettingOutlined,
  FileTextOutlined,
  ThunderboltOutlined,
  DatabaseOutlined,
  RobotOutlined,
  SafetyOutlined,
  ApiOutlined,
} from '@ant-design/icons';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import avatar from '@/assets/images/avatar.png';
import type { MenuProps } from 'antd';
import { useRequest } from 'ahooks';
import { getUserInfo, logout } from '@/api/user';
import styles from './BaseLayout.module.scss';

const { Header, Sider, Content } = Layout;

const BaseLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [collapsed, setCollapsed] = useState(false);

  const { data: userInfo = {} } = useRequest(getUserInfo);

  useEffect(() => {
    // 设置当前选中菜单项
    const path = location.pathname;
    if (path.startsWith('/modelConfig')) {
      setSelectedKeys(['modelConfigList']);
    } else if (path.startsWith('/prompt')) {
      setSelectedKeys(['promptList']);
    } else if (path.startsWith('/mcpServer')) {
      setSelectedKeys(['mcpServerList']);
    } else if (path.startsWith('/skill')) {
      setSelectedKeys(['skillList']);
    } else if (path.startsWith('/knowledgeBase')) {
      setSelectedKeys(['knowledgeBaseList']);
    } else if (path.startsWith('/agent')) {
      setSelectedKeys(['agentList']);
    } else if (path.startsWith('/tenantAuth')) {
      setSelectedKeys(['tenantAuthList']);
    } else if (path.startsWith('/user')) {
      setSelectedKeys(['userList']);
    }
  }, [location.pathname]);

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(`/${key}`);
  };

  const items: MenuProps['items'] = [
    // {
    //   key: 'info',
    //   label: (
    //     <Space direction="horizontal" size={0}>
    //       <Typography.Text strong>{userInfo.name}</Typography.Text>
    //       <Typography.Text type="secondary">（{userInfo.username}）</Typography.Text>
    //     </Space>
    //   ),
    // },
    {
      key: 'logout',
      label: (
        <div
          className="flex justify-between"
          onClick={() => {
            logout().then(() => {
              window.location.href = '/login?redirect=' + encodeURIComponent(window.location.href);
            });
          }}
        >
          退出 <LogoutOutlined />
        </div>
      ),
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh', minWidth: '1366px' }}>
      <Sider collapsible onCollapse={collapsed => setCollapsed(collapsed)}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '16px 0 16px 24px',
            borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
            gap: '8px',
            fontSize: '18px',
            color: '#fff',
            transition: 'all 0.3s ease-in-out',
            textOverflow: 'clip',
          }}
        >
          <img src={avatar} alt="logo" style={{ width: '32px', height: '32px' }} />
          {!collapsed && <span>智慧能源助手</span>}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={selectedKeys}
          onClick={handleMenuClick}
          items={[
            {
              key: 'modelConfigList',
              icon: <SettingOutlined />,
              label: '模型配置管理',
            },
            {
              key: 'promptList',
              icon: <FileTextOutlined />,
              label: '提示词管理',
            },
            {
              key: 'mcpServerList',
              icon: <ApiOutlined />,
              label: 'MCP Server 管理',
            },
            {
              key: 'skillList',
              icon: <ThunderboltOutlined />,
              label: 'Skill 管理',
            },
            {
              key: 'knowledgeBaseList',
              icon: <DatabaseOutlined />,
              label: '知识库管理',
            },
            {
              key: 'agentList',
              icon: <RobotOutlined />,
              label: '智能体管理',
            },
            {
              key: 'tenantAuthList',
              icon: <SafetyOutlined />,
              label: '租户授权管理',
            },
            {
              key: 'userList',
              icon: <UserOutlined />,
              label: '用户管理',
            },
          ]}
        />
      </Sider>
      <Layout>
        <Header className={`${styles.header} flex justify-between items-center px-4`}>
          <div></div>
          <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
            <div className={`${styles.menuTrigger} flex gap-2 items-center text-sm cursor-pointer`}>
              <Avatar style={{ backgroundColor: 'var(--color-primary)' }}>{userInfo?.name?.charAt(0) || '?'}</Avatar>
              {userInfo?.name ?? '未登录'}
              <DownOutlined />
            </div>
          </Dropdown>
        </Header>
        <Content style={{ margin: '16px', padding: 24, background: '#fff' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default BaseLayout;
